module.exports = "<div *ngIf='utils.isAdmin'>\n\n  <div *ngIf='isNewProject'>\n    <h1>New project</h1>\n    <app-project-box [isEdit]='true'></app-project-box>\n  </div>\n\n  \n\n  <div *ngIf='isEditCriterion && target'>\n    <h1>Edit Criterion: {{target.title}}</h1>\n    <app-criterion-summary [isEdit]='true'\n        [criterion]='target'></app-criterion-summary>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin-page/admin-page.component.html
// module id = 415
// module chunks = 0